// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface LearningObjective
 */
export interface LearningObjective {
    /**
     * 
     * @type {number}
     * @memberof LearningObjective
     */
    readonly id?: number;
    /**
     * Description of what the student will be able to do
     * @type {string}
     * @memberof LearningObjective
     */
    description: string;
}

export function LearningObjectiveFromJSON(json: any): LearningObjective {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': json['description'],
    };
}

export function LearningObjectiveToJSON(value?: LearningObjective): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'description': value.description,
    };
}


